export default __webpack_public_path__ + "static/media/podium-background.2dcb93ee.png";